module.exports = __webpack_public_path__ + "img/bronze-medal.c93e45df.svg";